const SUPPORTED_VIDEO_EXTENSIONS = [
  ".mp4",
  ".avi",
  ".mov",
  ".wmv",
  ".flv",
  ".webm",
  ".mkv",
  ".m4v",
  ".mpeg",
  ".mpg",
  ".3gp",
  ".ogv",
];

/**
 * Клон референсного isVideoFile (Rightholder/Videos/utils/validateVideoFile.js):
 * сначала проверяем MIME-тип, а если он пуст/не начинается с "video" —
 * фолбэк по расширению (нужен для форматов вроде .mkv, у которых MIME в
 * некоторых браузерах/ОС не определяется как video/*).
 *
 * Используется и в drag&drop (UploadsZone), и при выборе файла через диалог
 * (CreateVideoDialog), чтобы оба входа принимали одинаковый набор файлов.
 */
export function isVideoFile(file: File): boolean {
  if (file.type && file.type.startsWith("video")) {
    return true;
  }

  const fileName = file.name.toLowerCase();
  return SUPPORTED_VIDEO_EXTENSIONS.some((ext) => fileName.endsWith(ext));
}
